import { Box, ToggleButtonGroup as MuiToggleButtonGroup } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const HistoricalOverviewContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.small}px;
  width: 100%;
  padding: ${theme.spacing.small}px ${theme.spacing.medium}px ${theme.spacing.medium}px;
  overflow-y: auto;
  height: calc(100vh - 180px);
  background: ${theme.colors.pageBackground};

  ::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
    background: ${theme.colors.legacyBorderLow2};
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.legacyTextPrimary2};
    border-radius: ${theme.attributes.borderRadius.quaternary};
    html[data-theme='light'] & {
      background-color: ${theme.colors.borderMedium};
    }
  }
`

export const ChartCard = styled(Box)`
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.tertiary};
  padding: ${theme.spacing.medium}px;
  position: relative;

  .chart-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${theme.spacing.small}px;

    .chart-card-title {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.xSmall}px;
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
    }
  }
`

export const BreakdownRow = styled(Box)`
  display: flex;
  gap: ${theme.spacing.medium}px;
  width: 100%;
`

export const BreakdownCard = styled(ChartCard)`
  flex: 1;
  min-width: 0;
  height: 440px;
  display: flex;
  flex-direction: column;
`

export const ChartWrapper = styled(Box)`
  position: relative;
  width: 100%;
  overflow: hidden;
`

export const ChartTooltip = styled(Box)`
  display: none;
  position: absolute;
  width: 213px;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid ${theme.colors.menuItemHover};
  background: ${theme.colors.surfaceContainerBackground};
  box-shadow: ${theme.colors.tooltipShadow};
  color: ${theme.colors.foreground};
  font-family: ${theme.typography.fontFamily.primary};
  z-index: 9999;
  pointer-events: none;

  .tooltip-title-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: ${theme.colors.foreground};
  }

  .tooltip-row {
    display: flex;
    align-items: center;
    gap: 8px;

    & + .tooltip-row {
      margin-top: 12px;
    }
  }

  .tooltip-indicator {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 2px;
    flex-shrink: 0;
  }

  .tooltip-label {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${theme.colors.textSecondary};
  }

  .tooltip-value {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${theme.colors.foreground};
    margin-left: auto;
  }

  .tooltip-value-unit {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${theme.colors.textSecondary};
  }
`

export const LegendContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 54px;
  padding-top: ${theme.spacing.small}px;
  flex-wrap: wrap;
`

export const LegendItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xsm}px;

  .legend-indicator {
    width: 12px;
    height: 12px;
    border-radius: 2px;
  }

  .legend-line-indicator {
    width: 24px;
    height: 2px;
  }

  .legend-dashed-indicator {
    width: 24px;
    height: 0;
    border-top: 2px dashed;
  }

  .legend-label {
    color: ${theme.colors.foreground};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.5px;
  }
`

export const BreakdownToggle = styled(MuiToggleButtonGroup)`
  border-radius: 8px;
  background: ${theme.colors.btnSecondaryHoverBg};
  padding: 2px;

  .MuiToggleButton-root {
    border: none;
    border-radius: 6px !important;
    background: transparent;
    color: ${theme.colors.textSecondary};
    width: 48px;
    height: 48px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &.Mui-selected {
      border: 1px solid ${theme.colors.legacy4e444b2};
      background: ${theme.colors.legacy4e444b};
      color: ${theme.colors.cta};

      &:hover {
        background: ${theme.colors.legacy4e444b};
      }
    }

    &:hover {
      background: ${theme.colors.legacyAlpha5};
    }
  }

  &.no-data {
    background: ${theme.colors.legacyAlpha6};

    .MuiToggleButton-root {
      color: ${theme.colors.textSecondary};
      pointer-events: none;

      &.Mui-selected {
        border-color: ${theme.colors.btnSecondaryHoverBg};
        background: ${theme.colors.btnSecondaryHoverBg};

        &:hover {
          background: ${theme.colors.btnSecondaryHoverBg};
        }
      }
    }
  }
`

export const LoadingContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: ${theme.colors.cta};
`
